import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectSmsConfigurationsListItems } from "../../../../../redux/sms-configuration/selector";
import { smsConfigurations } from "../../../../../redux/sms-configuration/action";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table-manager/v1.1/table";

const ManagementSmsConfigurations = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const smsConfigurationsItems = useSelector(selectSmsConfigurationsListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      {
        field: 'GreenAdsGlobal.ServiceProvider', headerName: 'Service Provider', searchField: 'ServiceProvider', filter: true,
        filterType: 'text'
      },
      { field: 'GreenAdsGlobal.SenderName', headerName: 'Sender Name', },
      { field: 'GreenAdsGlobal.DomainName', headerName: 'Domain Name', },
    ]);
  }

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "ServiceProvider",
        FieldText: "ServiceProvider",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(smsConfigurations.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configurations/sms/list`,
      entity: 'smsConfigurations',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }))
  }

  const handleReloadData = () => {
    dispatch(smsConfigurations.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configurations/sms/list`,
      entity: 'smsConfigurations',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }

  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }

  const fetchSmsConfigurations = () => {
    dispatch(smsConfigurations.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configurations/sms/list`,
      entity: 'smsConfigurations',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }
  const handleAdd = () => {
    navigate(`${0}`);
  };

  const additionButtons: any = [


    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,

      callback: () => handleReloadData(),
    },
  ];

  useEffect(() => {
    createColumnDefs()
    fetchSmsConfigurations()
  }, [pageData, pageSize])

  const handleDelete = (data: any) => {
    dispatch(smsConfigurations.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configurations/sms/delete`,
      entity: 'smsConfigurations',
      jsonData: {
        Context: {},

        Records: [
          {
            Id: data?.Id
          }
        ]
      }
    })).then(() => {
      fetchSmsConfigurations();
    });
  }
  return (
    <>
      {smsConfigurationsItems?.isLoading ? <PageLoader /> :
        <Table
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          enableFilter={true}
          onSearch={handleSearch} columnData={columnDefs}
          rowData={smsConfigurationsItems?.result?.items} setPageData={setPageData}
          setPageSize={setPageSize} paginationData={smsConfigurationsItems?.result?.pagination}
          onEdit={handleEdit} additionButtons={additionButtons}
          onDelete={handleDelete} headingName="Sms Configurations"
        />
      }
    </>
  );
};

export default ManagementSmsConfigurations;